import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import webClient from '../../core/web_client';
import { FOOD_PARTNERS_PATH } from '../../core/constants';
import { extractErrorData, extractResponseData } from '../../core/utils/api_utils';
import { DEFAULT_STATE, STATE__API__FAIL, STATE__API__STARTED, STATE__API__SUCCESS } from '../../core/utils/store_utils';
import { invalidateToken } from '../authorization/get_token';

export const createFoodPartnerAction = createAsyncThunk(
    'foodPartner/createFoodPartnerAction',
    async (data, { fulfillWithValue, rejectWithValue }) => {
        try {
            const response = await webClient.post(`${ FOOD_PARTNERS_PATH }`, data.form);
            return fulfillWithValue(extractResponseData(response));
        } catch (error) {
            return rejectWithValue(extractErrorData(error));
        }
    }
);

const createFoodPartnerSlice = createSlice({
    name: 'createFoodPartnerSlice',
    initialState: DEFAULT_STATE,
    reducers: {},
    extraReducers: builder => {
        builder.addCase(createFoodPartnerAction.pending, () => STATE__API__STARTED);
        builder.addCase(createFoodPartnerAction.fulfilled, (_, { payload }) => STATE__API__SUCCESS(payload));
        builder.addCase(createFoodPartnerAction.rejected, (_, { payload }) => STATE__API__FAIL(payload));
        builder.addCase(invalidateToken, () => DEFAULT_STATE);
    }
});

export const createFoodPartnerState = (state) => state.foodPartner.createFoodPartner;
export default createFoodPartnerSlice.reducer;
